import { debug } from "console";

//turn on - off on loggers
const errorlogger = true;
const debuglogger = false;

export const ErrorLogger = (message: string, alertMode: boolean = false) => {
    if (errorlogger) {
        const stack = new Error().stack;
        if (!alertMode)
            console.log('Error: ' + message + '\n' + 'Stack:' + stack);
        else
            alert('Error: ' + message + '\n' + 'Stack:' + stack);
    }
}
export const DebugLogger = (message: string, alertMode: boolean = false) => {
    if (debuglogger) {
        const stack = new Error().stack;
        if (!alertMode) 
            console.log('Debug: ' + message + '\n' + 'Stack:' + stack);
        else
            alert('Debug: ' + message + '\n' + 'Stack:' + stack);
    }
}